<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kgKTb3/tc-custom/FC-9781528997935.jpg?1685203882216?1705541262411" alt="This image is the cover for the book My Fur, My Skin, My Scars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Fur, My Skin, My Scars
      </h1>
      <p class="bookDescription body article font2">
        <p>When they find a mysterious hatch, Vortex, Rin and Blue, merely acquaintances, are hurled into the middle of a war-torn world. With five others, they travel deep into every clan, learn its secrets and eventually go to war. However, while they hunt for these secrets in the shadows, they soon realize that there are more questions within the group than outside of it.<br/>This isn’t the story of three clans driven apart by war. This is a story of eight people, what makes them similar and different, what brings them together and drives them apart and, ultimately, what keeps them alive.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elisa
      </h2>
      
      <p class="authorDescription body article">Elisa was born in Tirana, Albania, in 2007. In 2017, she moved to England. My Fur, My Skin, My Scars is her first book, which she finished writing in 2019.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?936d45ae